import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Replace this with your actual GIF import or path
import INTRO_GIF from "./MainComponent/spinningProduct.webp"; 

const EngulfWrapper = ({ children }) => {
  const [isTransitioned, setIsTransitioned] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioned(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white font-sans overflow-hidden relative">
      
      {/* SECTION 1: The "Create" Intro Stage */}
      <AnimatePresence>
        {!isTransitioned && (
          <motion.div
            key="intro-content"
            initial={{ opacity: 1 }}
            exit={{ 
              opacity: 0, 
              scale: 1.1,
              filter: "blur(20px)",
              transition: { duration: 1, ease: "easeInOut" } 
            }}
            className="fixed inset-0 z-10 flex flex-col items-center justify-center pointer-events-none"
          >

            {/* ── Flowing lines background ─────────────────────────────── */}
            <style>{`
              @keyframes flow-a {
                0%   { d: path("M-200,580 C150,460 350,280 600,320 C850,360 1000,180 1400,200"); }
                25%  { d: path("M-200,520 C100,400 380,240 620,300 C860,360 1050,140 1400,180"); }
                50%  { d: path("M-200,480 C200,380 420,200 640,260 C860,320 1020,120 1400,160"); }
                75%  { d: path("M-200,540 C130,420 360,260 610,310 C860,360 1040,160 1400,190"); }
                100% { d: path("M-200,580 C150,460 350,280 600,320 C850,360 1000,180 1400,200"); }
              }
              @keyframes flow-b {
                0%   { d: path("M-200,420 C200,340 420,480 680,380 C940,280 1100,400 1400,360"); }
                33%  { d: path("M-200,380 C180,300 450,440 700,350 C950,260 1120,380 1400,330"); }
                66%  { d: path("M-200,460 C220,360 400,500 660,400 C920,300 1080,420 1400,390"); }
                100% { d: path("M-200,420 C200,340 420,480 680,380 C940,280 1100,400 1400,360"); }
              }
              @keyframes flow-c {
                0%   { d: path("M-200,680 C300,600 500,440 720,500 C940,560 1150,380 1400,440"); }
                40%  { d: path("M-200,640 C280,560 520,400 740,470 C960,540 1170,340 1400,410"); }
                80%  { d: path("M-200,720 C320,640 480,480 700,530 C920,580 1130,400 1400,470"); }
                100% { d: path("M-200,680 C300,600 500,440 720,500 C940,560 1150,380 1400,440"); }
              }
              @keyframes flow-d {
                0%   { d: path("M-200,240 C250,180 480,320 720,220 C960,120 1200,280 1400,180"); }
                50%  { d: path("M-200,200 C270,140 500,280 740,190 C980,100 1220,260 1400,150"); }
                100% { d: path("M-200,240 C250,180 480,320 720,220 C960,120 1200,280 1400,180"); }
              }
              @keyframes flow-e {
                0%   { d: path("M-200,760 C180,700 460,580 740,640 C1020,700 1180,540 1400,600"); }
                60%  { d: path("M-200,720 C200,660 440,540 760,610 C1080,680 1200,510 1400,570"); }
                100% { d: path("M-200,760 C180,700 460,580 740,640 C1020,700 1180,540 1400,600"); }
              }
              @keyframes flow-f {
                0%   { d: path("M-200,100 C300,60 560,200 800,120 C1040,40 1260,180 1400,100"); }
                50%  { d: path("M-200,140 C280,80 540,220 820,140 C1100,60 1280,200 1400,130"); }
                100% { d: path("M-200,100 C300,60 560,200 800,120 C1040,40 1260,180 1400,100"); }
              }
              .fl-a { animation: flow-a 12s ease-in-out infinite; }
              .fl-b { animation: flow-b 14s ease-in-out 2s infinite; }
              .fl-c { animation: flow-c 16s ease-in-out 1s infinite; }
              .fl-d { animation: flow-d 11s ease-in-out 3s infinite; }
              .fl-e { animation: flow-e 18s ease-in-out 0.5s infinite; }
              .fl-f { animation: flow-f 13s ease-in-out 4s infinite; }
            `}</style>

            <svg
              viewBox="0 0 1400 800"
              preserveAspectRatio="xMidYMid slice"
              xmlns="http://www.w3.org/2000/svg"
              style={{ position:"absolute", inset:0, width:"100%", height:"100%", pointerEvents:"none" }}
            >
              <defs>
                <linearGradient id="lg-a" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%"   stopColor="#0c1a6e" stopOpacity="0"/>
                  <stop offset="20%"  stopColor="#1a3aff" stopOpacity="0.9"/>
                  <stop offset="50%"  stopColor="#38bdf8" stopOpacity="1"/>
                  <stop offset="80%"  stopColor="#1a3aff" stopOpacity="0.8"/>
                  <stop offset="100%" stopColor="#0c1a6e" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="lg-b" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%"   stopColor="#06174a" stopOpacity="0"/>
                  <stop offset="30%"  stopColor="#2563eb" stopOpacity="0.75"/>
                  <stop offset="55%"  stopColor="#7dd3fc" stopOpacity="0.95"/>
                  <stop offset="75%"  stopColor="#2563eb" stopOpacity="0.7"/>
                  <stop offset="100%" stopColor="#06174a" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="lg-c" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%"   stopColor="#030d2e" stopOpacity="0"/>
                  <stop offset="25%"  stopColor="#1d4ed8" stopOpacity="0.6"/>
                  <stop offset="60%"  stopColor="#93c5fd" stopOpacity="0.85"/>
                  <stop offset="85%"  stopColor="#1d4ed8" stopOpacity="0.55"/>
                  <stop offset="100%" stopColor="#030d2e" stopOpacity="0"/>
                </linearGradient>
                <filter id="fl-glow-sm"><feGaussianBlur stdDeviation="1.5"/></filter>
                <filter id="fl-glow-md"><feGaussianBlur stdDeviation="3"/></filter>
                <filter id="fl-glow-lg"><feGaussianBlur stdDeviation="6"/></filter>
              </defs>

              {/* Line A — primary hero ribbon */}
              <path className="fl-a" fill="none" stroke="url(#lg-a)" strokeWidth="22" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,580 C150,460 350,280 600,320 C850,360 1000,180 1400,200"/>
              <path className="fl-a" fill="none" stroke="url(#lg-a)" strokeWidth="6"  filter="url(#fl-glow-sm)" strokeLinecap="round" d="M-200,580 C150,460 350,280 600,320 C850,360 1000,180 1400,200"/>
              <path className="fl-a" fill="none" stroke="url(#lg-a)" strokeWidth="1.5" strokeLinecap="round" d="M-200,580 C150,460 350,280 600,320 C850,360 1000,180 1400,200"/>


              {/* Line B — counter-flow ribbon */}
              <path className="fl-b" fill="none" stroke="url(#lg-b)" strokeWidth="18" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,420 C200,340 420,480 680,380 C940,280 1100,400 1400,360"/>
              <path className="fl-b" fill="none" stroke="url(#lg-b)" strokeWidth="5"  filter="url(#fl-glow-sm)" strokeLinecap="round" d="M-200,420 C200,340 420,480 680,380 C940,280 1100,400 1400,360"/>
              <path className="fl-b" fill="none" stroke="url(#lg-b)" strokeWidth="1.2" strokeLinecap="round" d="M-200,420 C200,340 420,480 680,380 C940,280 1100,400 1400,360"/>


              {/* Line C — lower sweep */}
              <path className="fl-c" fill="none" stroke="url(#lg-c)" strokeWidth="14" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,680 C300,600 500,440 720,500 C940,560 1150,380 1400,440"/>
              <path className="fl-c" fill="none" stroke="url(#lg-c)" strokeWidth="4"  filter="url(#fl-glow-md)" strokeLinecap="round" d="M-200,680 C300,600 500,440 720,500 C940,560 1150,380 1400,440"/>
              <path className="fl-c" fill="none" stroke="url(#lg-c)" strokeWidth="1"  strokeLinecap="round" d="M-200,680 C300,600 500,440 720,500 C940,560 1150,380 1400,440"/>


              {/* Line D — upper arc */}
              <path className="fl-d" fill="none" stroke="url(#lg-b)" strokeWidth="16" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,240 C250,180 480,320 720,220 C960,120 1200,280 1400,180"/>
              <path className="fl-d" fill="none" stroke="url(#lg-b)" strokeWidth="5"  filter="url(#fl-glow-sm)" strokeLinecap="round" d="M-200,240 C250,180 480,320 720,220 C960,120 1200,280 1400,180"/>
              <path className="fl-d" fill="none" stroke="url(#lg-b)" strokeWidth="1.2" strokeLinecap="round" d="M-200,240 C250,180 480,320 720,220 C960,120 1200,280 1400,180"/>


              {/* Line E — deep background, no march */}
              <path className="fl-e" fill="none" stroke="url(#lg-c)" strokeWidth="20" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,760 C180,700 460,580 740,640 C1020,700 1180,540 1400,600"/>
              <path className="fl-e" fill="none" stroke="url(#lg-c)" strokeWidth="4"  filter="url(#fl-glow-md)" strokeLinecap="round" d="M-200,760 C180,700 460,580 740,640 C1020,700 1180,540 1400,600"/>

              {/* Line F — top whisper */}
              <path className="fl-f" fill="none" stroke="url(#lg-a)" strokeWidth="12" filter="url(#fl-glow-lg)" strokeLinecap="round" d="M-200,100 C300,60 560,200 800,120 C1040,40 1260,180 1400,100"/>
              <path className="fl-f" fill="none" stroke="url(#lg-a)" strokeWidth="1"  strokeLinecap="round" d="M-200,100 C300,60 560,200 800,120 C1040,40 1260,180 1400,100"/>

            </svg>

            {/* Radial vignette — keeps centre dark so content stays readable */}
            <div style={{
              position:"absolute", inset:0, pointerEvents:"none",
              background:"radial-gradient(ellipse 75% 65% at 50% 50%, transparent 25%, rgba(0,0,4,0.85) 100%)",
            }}/>
            {/* ── End flowing lines ──────────────────────────────────────── */}

            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
              className="text-sm uppercase tracking-[0.35em] text-blue-300/70 mb-4 relative z-10"
            >
              ✦ the squad awaits ✦
            </motion.p>
            <motion.h1 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-7xl md:text-8xl font-medium mb-2 tracking-tight relative z-10"
            >
              Meet your
            </motion.h1>
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.35 }}
              className="text-7xl md:text-8xl font-medium mb-3 tracking-tight relative z-10 flex items-center gap-3 justify-center"
            >
              <span style={{
                background: "linear-gradient(90deg, #38BDF8, #7DD3FC, #FCD34D, #38BDF8)",
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                animation: "shimmer-engulf 3s linear infinite",
              }}>
                Toothyz!
              </span>
              <span style={{ WebkitTextFillColor: "initial" }}>🦷</span>
            </motion.h1>

            <style>{`
              @keyframes shimmer-engulf {
                0%   { background-position: 0% center; }
                100% { background-position: 200% center; }
              }
            `}</style>

            <div className="relative w-full max-w-2xl aspect-video mb-10 flex justify-center z-10">
              <div className="w-64 h-64 bg-blue-500/20 rounded-full blur-3xl absolute animate-pulse" />
              <img 
                src={INTRO_GIF} 
                alt="Toothyz Squad" 
                className="w-full h-full object-contain relative z-10"
              />
            </div>
            
            <button className="bg-blue-600/20 border border-blue-400/50 backdrop-blur-xl px-10 py-4 rounded-full text-lg opacity-50 relative z-10 tracking-wide">
              🌟 Gathering the Squad...
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* SECTION 2: The Engulfing Page Container */}
      <motion.div
        initial={{ y: "100vh", borderRadius: "50% 50% 0 0" }}
        animate={isTransitioned ? { 
          y: 0, 
          borderRadius: "0% 0% 0 0",
        } : { y: "100vh" }}
        transition={{ 
          duration: 1.2, 
          ease: [0.22, 1, 0.36, 1] 
        }}
        className="absolute inset-0 z-20 w-full h-full overflow-y-auto bg-black"
      >
        {/* Render the actual page content here */}
        {children}
      </motion.div>

    </div>
  );
};

export default EngulfWrapper;